import React, { useState, useEffect } from 'react';

import { Box, Modal, IconButton } from '@mui/material';
import { Heading, style } from './Elements';
import { pinCodeFieldStyles } from '../InputFields/styles';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { CustomGreenLargeButton } from '../../components/Button';
import Loader from '../../assets/loader1.gif';
import toast from 'react-hot-toast';
import { LoaderSpan } from '../../pages/SignIn/Elements';
import CloseIcon from '@mui/icons-material/Close';

export const OtpVerification = ({
  phoneNumber,
  open,
  handle,
  stateName,
  updateProfileFunction,
  resendOtpFunction,
}) => {
  const handleClose = () => handle([stateName], false);

  const classes = pinCodeFieldStyles();
  const [pin, setPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(60); // 60 seconds countdown
  const [canResend, setCanResend] = useState(false);

  // Countdown timer for resend functionality
  useEffect(() => {
    let interval = null;
    if (open && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [open, resendTimer]);

  // Reset timer when modal opens
  useEffect(() => {
    if (open) {
      setResendTimer(60);
      setCanResend(false);
      setPin('');
    }
  }, [open]);

  const handleChange = (newValue) => {
    setPin(newValue);
  };

  const handleResendOtp = async () => {
    if (!canResend) return;
    
    try {
      setIsLoading(true);
      if (resendOtpFunction) {
        await resendOtpFunction();
        setResendTimer(60);
        setCanResend(false);
        toast.success('OTP resent successfully!', { duration: 4000 });
      }
    } catch (error) {
      console.log(error,"error")
      toast.error('Failed to resend OTP. Please try again.', { duration: 4000 });
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOtp = (e) => {
    e.preventDefault();
    setIsLoading(true)
    const confirmationResult = window.confirmationResult;
    confirmationResult
      .confirm(pin)
      .then((result) => {
        toast.success(`Otp verified.`, { duration: 4000 });
        updateProfileFunction();
      })
      .catch((error) => {
        handleChange('openOtpModal', false);
        toast.error(`Invalid code.`, { duration: 4000 });
        handleChange('openOtpModal', false);
        setPin('')
      }).finally(()=>{
        setIsLoading(false)
      });
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  console.log(pin,"pin")
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: 450, height: 400, alignItems: 'center', pt: 3, px: 3, pb: 3, position: 'relative' }}>
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: '#666',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          
          <Heading>Enter the code we send over SMS to {phoneNumber} </Heading>

          <Box>
            <MuiOtpInput
              className={classes.root}
              value={pin}
              sx={{ gap: 1 }}
              length={6}
              onChange={handleChange}
              style={{fontSize:"1rem"}}
            />
          </Box>

          <CustomGreenLargeButton onClick={verifyOtp} variant="contained" disableripple disabled={isLoading || pin.length !== 6}>
            {isLoading ? (
              <LoaderSpan>
                <img src={Loader} width={30} alt="loading..." style={{ marginRight: 6 }} />
                Submiting...
              </LoaderSpan>
            ) : (
              ' Submit Code'
            )}
          </CustomGreenLargeButton>

          {/* Resend OTP Section */}
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            {canResend ? (
              <Box
                onClick={handleResendOtp}
                sx={{
                  cursor: 'pointer',
                  color: '#3C6B49',
                  fontSize: '14px',
                  textDecoration: 'underline',
                  '&:hover': {
                    color: '#2a4f35',
                  },
                }}
              >
                Resend OTP
              </Box>
            ) : (
              <Box sx={{ color: '#666', fontSize: '14px' }}>
                Resend OTP in {formatTime(resendTimer)}
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
